import { saveAs } from "file-saver";

/**
 * Saves a chat file under its own name. `<a download>` is ignored for files on
 * another host (they'd just open in a tab), so it is fetched and saved from a
 * blob; if the host refuses the fetch, it opens instead.
 */
export const downloadChatFile = async (url: string, fileName: string) => {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(String(res.status));
    saveAs(await res.blob(), fileName);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
